import { useContext } from "react";
import cn from "classnames";
import { Textbox as CommonTextbox, TextboxFieldProps } from "capitalrx-components-2.0/lib/forms";

import { ThemeSelectorContext } from "@/basic/context";

import styles from "../styles.module.scss";

export const Textbox = (props: TextboxFieldProps) => {
  const { client } = useContext(ThemeSelectorContext);

  const textboxClass = cn(styles["InputWidth"], { [styles["TextboxWrapper"]]: !!client }, styles[`${props?.className}`]);

  return <CommonTextbox.Field {...props} className={textboxClass} />;
};
